export const SURVEY_SESSION_SCHEMA = {
  title: 'survey session schema',
  version: 0,
  description: 'Stores the state of an active survey session',
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100, // RxDB requires maxLength for primary keys
    },
    survey_id: {
      type: 'number',
    },
    survey_version: {
      type: 'number',
    },
    current_page_id: {
      type: 'number',
    },
    session_status: {
      type: 'string',
    },
    session_unique_identifier: {
      type: 'string',
      nullable: true
    },
    survey_language: {
      type: 'string',
      default: 'en',
    },
    // The Bot Engine stores its logic state here
    jsn_session_state: {
      type: 'object',
    },
    // This is where user answers are saved
    jsn_responses: {
      type: 'object',
      additionalProperties: true,
    },
    jsn_activity_order: {
      type: 'array',
      items: { type: 'object' },
    },
    jsn_constructed_lists: {
      type: 'object',
    },
    jsn_oe_mapping: {
      type: 'object',
    },
    jsn_passive_media: {
      type: 'array',
      items: { type: 'object' },
    },
    sys_survey_start_time: {
      type: 'string',
      format: 'date-time',
    },
    sys_survey_end_time: {
      type: 'string',
      nullable: true,
    },
    sys_last_updated: {
      type: 'string',
      format: 'date-time',
    },
    sys_disposition_code: {
      type: 'number',
      nullable: true,
    },
    sys_jsn_device_data: {
      type: 'object',
    },
    sys_profile_identifier: {
      type: 'string',
      nullable: true,
    },
    sys_survey_delivery_status: {
      type: 'string',
      nullable: true,
    },
    // NEW TRACKING FIELDS
    updated_at: {
      type: 'string', // Unix timestamp
    },
    sync_status: {
      type: 'string',
      enum: ['synced', 'dirty', 'syncing', 'error'],
      default: 'dirty',
    },
    last_sync_time: {
      type: 'string', // ISO String
    },
  },

  required: ['id', 'survey_id', 'session_status'],
};
